import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router';
import type { BudgetChangeOrderListItem } from '@/api/Sherpa/ChangeOrder';
import { tdmStatus } from '@/constants/Project';
import { ActionsCell } from '@/features/ChangeOrder/Summary/Table/ActionsCell';
import { EditableCell } from '@/features/ChangeOrder/Summary/Table/EditableCell';
import { EditableStatus } from '@/features/ChangeOrder/Summary/Table/EditableStatus';
import type { ColMeta } from '@/features/ChangeOrder/Summary/Table/types';
import { useDeleteBudgetChangeOrder } from '@/hooks/ReactQueryHooks/useChangeOrderDetailsQuery';
import { accountingFormatNumber } from '@/utils';

const columnHelper = createColumnHelper<BudgetChangeOrderListItem>();

export const columns = [
  columnHelper.accessor('lineItem', {
    header: 'Line Item',
    size: 120,
    cell: EditableCell,
    meta: {
      type: 'text',
      renderValue: ({ row, cell }) => (
        <Link className='underline' to={`budget/${row.original.id}`}>
          {cell.getValue()}
        </Link>
      ),
    } as ColMeta,
  }),
  columnHelper.accessor('fromAmount', {
    header: 'From',
    size: 170,
    cell: ({ cell }) => accountingFormatNumber({ num: cell.getValue() }),
  }),
  columnHelper.accessor('toAmount', {
    header: 'To',
    size: 170,
    cell: ({ cell }) => accountingFormatNumber({ num: cell.getValue() }),
  }),
  columnHelper.accessor('budgetImpacted', {
    header: 'Impact ($)',
    size: 150,
    cell: ({ cell }) => accountingFormatNumber({ num: cell.getValue() }),
  }),
  columnHelper.accessor('approver', {
    header: 'Approver',
    size: 150,
    cell: EditableCell,
    meta: {
      renderValue: ({ row }) => row.original.approver.name,
    } as ColMeta,
  }),
  columnHelper.accessor('responseDueBy', {
    header: 'Response Due By',
    size: 150,
    cell: EditableCell,
    meta: {
      type: 'date',
    },
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    size: 150,
    cell: EditableStatus,
    meta: {
      options: Object.keys(tdmStatus).map((ts) => ({
        label: tdmStatus[ts],
        value: ts,
      })),
    },
  }),
  columnHelper.display({
    header: 'Actions',
    size: 100,
    cell: ActionsCell,
    meta: {
      deleteModalTitle: 'Are you sure you want to delete budget line item?',
      useDeleteMutation: useDeleteBudgetChangeOrder,
    },
  }),
];
